/**
 * @Desription: 方法-格式化树结构
 * @Author: netstar.sjj
 * @Date: 2021-10-26 16:05:00
 * @names: formatTree
*/
namespace formatTree{
    /**
     * list数据设置节点展开
     * @param  {any} rows
     * @param  {any} options?
     */
    const settingOpenForTreeNode:Function = function(rows:any,options:any){
        let idFieldStr:string = options.idField ? options.idField : 'id';
        if(options.type == 'id' && options.value){
            //根据id指定哪些节点处于展开
            for (let idI = 0; idI < rows.length; idI++) {
                if (options.value.indexOf(rows[idI][idFieldStr]) > -1) {
                    rows[idI].open = true;
                }
            }
        }else if(options.type == 'field' && options.value){
            //根据指定的field字段去读取展开 如rows[idI].isOpen
            for (let idI = 0; idI < rows.length; idI++) {
                rows[idI].open = rows[idI][options.value[0]];
            }
        }else if(options.type == 'level' && options.value){
            //指定展开几层
            switch(options.value){
                case -1:
                    // -1表示全部节点都展开
                    for (let idI = 0; idI < rows.length; idI++) {
                        rows[idI].open = true;
                    }
                    break;
            }
        }
    }
    /**
     * list数据格式化返回树结构的数据
     * @param  {any} rows
     * @param  {any} options?
     */
    const getTreeData:Function = function(rows:any,options?:any){
        if(typeof(options)!='object'){
            options = {
                idField:'id',
                parentIdField:'parentId',
                childIdField:'children',
            };
        }
        let idMap:any = {};
        let dataArray = Array.isArray(rows) ? rows : [];
        let idFieldStr:string = options.idField ? options.idField : 'id';
        let parentIdStr:string = options.parentIdField ? options.parentIdField : 'parentId';
        let childIdStr:string = options.childIdField ? options.childIdField :'children';
        for (let i = 0; i < dataArray.length; i++) {
            idMap[dataArray[i][idFieldStr]] = dataArray[i];
        }
        let result:any = [];
        for (let i = 0; i < dataArray.length; i++) {
            let row = dataArray[i];
            if (row[parentIdStr] && idMap[row[parentIdStr]]) {
                let parent = idMap[row[parentIdStr]];
                if (!Array.isArray(parent[childIdStr])) {
                    parent[childIdStr] = [];
                }
                parent.isParent = true;
                parent[childIdStr].push(row);
            } else {
                result.push(row);
            }
        }
        return result;
    }
    /**
     * 把list数据转换成树格式的数据
     * @param  {any} rows
     * @param  {any} options?
     */
    export function converToTree(rows:any,options?:any){
        if(typeof(options)!='object'){
            options = {
                idField:'id',
                parentIdField:'parentId',
                childIdField:'children',
            };
        }
        if(!Array.isArray(rows)){rows = [];}
        settingOpenForTreeNode(rows,options);//设置树节点展开
        let treeRowsArray = getTreeData(rows,options);//获取树结构的数据格式
        return treeRowsArray;//返回
    }
    export function converToList(rows:any,options:any){
        let treeRows:any = [];
        options = typeof(options)=='object' ? options : {};
        const isCountFirstNode:boolean = typeof(options.isCountFirstNode)=='boolean' ? options.isCountFirstNode : true;//默认计算第一级节点，如果配置了不计算则不计算
        const expandLevel:number = Number(options.level) ? options.level : 0;//默认展开层级
        let isExpandOpen:boolean = true;//默认是否打开
        if(expandLevel == -1){
            isExpandOpen = false;
        }
        const formatTreeData:Function = function(array:any, levelIndex:number, isHasParent:boolean,currentRowIndex:number) {
            if (!Array.isArray(array)) { return; }
            let isOpen:boolean = true;//是否显示
            let isExpand:boolean = isExpandOpen;//当前是父节点是否展开状态
            for(let rowI = 0; rowI < array.length; rowI++) {
                array[rowI].netstarLevel = levelIndex;
                array[rowI].netstarOpen = isOpen;
                array[rowI].netstarExpand = isExpand;
                if(isExpand === false){
                    if(levelIndex === 0){
                        array[rowI].netstarOpen = true;
                    }else{
                        array[rowI].netstarOpen = false;
                    }
                }
                array[rowI]['NETSTAR-AUTOSERIES'] = rowI+1;
                if(currentRowIndex > -1){
                    array[rowI]['NETSTAR-AUTOSERIES'] = (currentRowIndex+1) + '-'+(rowI+1);
                }
                let isChildren:boolean = true;
                if (!Array.isArray(array[rowI].children)) {
                    isChildren = false;
                } else {
                    if (array[rowI].children.length == 0) {
                        isChildren = false;
                    }
                }
                //计算PADDING-LEFT
                let leftNum:number = levelIndex * 15 + 15;
                if(isCountFirstNode === false){leftNum -= 15;}
                array[rowI].netstarStyleObj = {
                    'padding-left': leftNum + 'px',
                };
                if (levelIndex > 0) {
    
                } else {
                    if (!isChildren) {
                    } else {
                        array[rowI].netstarOpen = isOpen;
                    }
                }
                treeRows.push(array[rowI]);
                const nIndex:number = array[rowI].netstarLevel + 1;
                if (isChildren) {
                    array[rowI].isParent = true;
                    formatTreeData(array[rowI].children,nIndex,true,rowI);
                } else {
                    array[rowI].isParent = false;
                }
            }
        }
        formatTreeData(rows, 0, false);
        return treeRows;
    }
    export function getIdsDataBytreeList(rows:any,options:any){
        options = typeof(options)=='object' ? options : {};
        if(!Array.isArray(rows)){rows = [];}
        const idFieldStr:string = options.idField ? options.idField : 'id';
        const parentIdStr:string = options.parentField ? options.parentField : 'parentId';
        let idsData:any = {};
        let levelOneNodes:any = [];
        const forEachRowsData:Function = function(array:any,levelIndex:number) {
            if (!Array.isArray(array)) { return; }
            let currentLevelIndex:number = levelIndex;
            for(let arrI=0; arrI<array.length; arrI++){
                const arrData:any = array[arrI];
                idsData[arrData[idFieldStr]] = arrData;
                let isChildren:boolean = true;
                if (!Array.isArray(arrData.children)) {
                    isChildren = false;
                } else {
                    if (arrData.children.length == 0) {
                        isChildren = false;
                    }
                }
                if(isChildren){
                    currentLevelIndex = currentLevelIndex + 1;
                    forEachRowsData(arrData.children,currentLevelIndex);
                    if(currentLevelIndex === 1){
                        levelOneNodes.push(arrData);
                    }
                }else{
                    if(currentLevelIndex === 0){
                        levelOneNodes.push(arrData);
                    }
                }
            }
        }
        forEachRowsData(rows,0);
        return {
            idsData:idsData,
            levelOneNodes:levelOneNodes,
        };
    }//存储ids的数据，根据树结构的返回形式
    export function getAllChildIds(data:any,idField?:string,childField?:string){
        idField = idField ? idField : 'id';
        childField = childField?childField:"children";
        let ids:any = [];
        if(data.id){
            ids.push({id:data.id});
        }
        let childArray:any = [];
        if(Array.isArray(data[childField])){childArray = data[childField];}
        const forEachChildFun:Function = function(arrayData:any){
            if(Array.isArray(arrayData)){
                for(let dataI=0; dataI<arrayData.length; dataI++){
                    const dataObj:any = arrayData[dataI];
                    if(dataObj.id){
                        ids.push({id:dataObj.id});
                    }
                    if(Array.isArray(dataObj[childField])){
                        forEachChildFun(dataObj[childField]);
                    }
                }
            }
        }
        forEachChildFun(childArray);
        return ids;
    }
}
export default formatTree;